module.exports = __webpack_public_path__ + "static/media/info-icon.81986860.svg";